class Repository {
    post(url, data) {
        return axios.post(url, data)
            .then(resp => {
                return resp;
            }).catch((error) => {
                let response = error.response;
                if (response) {
                    let data = response.data;
                    if (typeof data.success !== 'undefined') {
                        return data;
                    }
                }
                return null;
            });
    }

    get(url, data = {}) {
        return axios.get(url, {
            params: data
        }).then(resp => {
            return resp;
        }).catch(error => {
            let response = error.response;
            if (response) {
                let data = response.data;
                if (typeof data.success !== 'undefined') {
                    return data;
                }
            }
            return null;
        });
    }
}

export default new Repository();